"use client";

import type React from "react";
import { InternalAuthProvider, useAuth } from "../hooks/useAuth";

export { useAuth };

interface AuthProviderProps {
	children: React.ReactNode;
}

export const AuthProvider = ({ children }: AuthProviderProps): React.ReactElement => {
	return <InternalAuthProvider>{children}</InternalAuthProvider>;
};
